const sendError = async (type, message, stack, url, severity = 'error') => {
    try {
        const token = localStorage.getItem('token')

        await fetch('/api/logs/error', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: JSON.stringify({ type, message, stack, url, severity })
        })
    } catch {
        // молча игнорируем ошибки логирования
    }
}

export const logJsError = (message, stack, url) => sendError('js', message, stack, url)
export const logFetchError = (message, url) => sendError('fetch', message, null, url)
export const logReactError = (message, stack, url) => sendError('react', message, stack, url, 'critical')
